const initialOfferState = {
    instoreOffers           : [ ],
    onlineOffers            : [ ],
    instoreLoadedPage       : 0,
    onlineLoadedPage        : 0,
    offerCategories         : [ ],
    categoriesLoaded        : false,
    featuredOffers          : [ ],
    featuredOffersLoaded    : false,
    favouriteOffers         : [ ],
    favouriteOffersLoaded   : false,
    singleOnlineOffer       : { },
    singleOnlineOfferLoaded : false,
    singleInstoreOffer      : { },
    singleInstoreOfferLoaded: false
}

const offerReducer = (state = initialOfferState, action) => {
    switch (action.type) {
        case 'LOAD_INSTORE_OFFERS':
            return Object.assign({}, state, {
                instoreOffers: action.newOffers,
                instoreLoadedPage: action.currentPage
            })
        case 'RESET_INSTORE_OFFERS':
            return Object.assign({}, state, {
                instoreOffers: [],
                instoreLoadedPage: 0
            })
        case 'LOAD_ONLINE_OFFERS':
            return Object.assign({}, state, {
                onlineOffers: action.newOffers,
                onlineLoadedPage: action.currentPage
            })
        case 'RESET_ONLINE_OFFERS':
            return Object.assign({}, state, {
                onlineOffers: [],
                onlineLoadedPage: 0
            })
        case 'LOAD_OFFER_CATEGORIES':
            return Object.assign({}, state, {
                offerCategories: action.categories,
                categoriesLoaded: true
            })
        case 'LOAD_FEATURED_OFFERS':
            return Object.assign({}, state, {
                featuredOffers: action.newOffers,
                featuredOffersLoaded: true
            })
        case 'LOAD_FAVORED_OFFERS':
            return Object.assign({}, state, {
                favouriteOffers: action.newOffers,
                favouriteOffersLoaded: true
            })
        case 'UNSET_FAVORITE_LOAD':
            return Object.assign({}, state, {
                favouriteOffersLoaded: false
            })
        case 'LOAD_SINGLE_ONLINE_OFFER':
            return Object.assign({}, state, {
                singleOnlineOffer: action.newOffer,
                singleOnlineOfferLoaded: true
            })
        case 'DISABLE_SINGLE_ONLINE_OFFER':
            return Object.assign({}, state, {
                singleOnlineOfferLoaded: false
            })
        case 'LOAD_SINGLE_INSTORE_OFFER':
            return Object.assign({}, state, {
                singleInstoreOffer: action.newOffer,
                singleInstoreOfferLoaded: true
            })
        case 'DISABLE_SINGLE_INSTORE_OFFER':
            return Object.assign({}, state, {
                singleInstoreOfferLoaded: false
            })
        default:
            return state
    }
}

export default offerReducer;